<template>
    <picture-element
            :lazy="false"
            :urls="getImage"/>
</template>

<script>
    import PictureElement from '../picture-element/picture-element';

    export default {
        components: { PictureElement },
        props: {
            urls: {
                type: Object,
                default() {
                    return {
                        default: [],
                    };
                },
            },
        },
        computed: {
            getImage() {
                return this.urls;
            },
        },
    };
</script>
